import { ADD_SET, ADD_MISTAKE, ADD_POINTS, SET_LEVEL, SET_LEVEL_ID, SET_MOVES, SET_FAILED, SCORE_STARS, SET_PALETTE } from '../actions/types';
import { PROPERTIES, failure_codes } from '../utilities';

/*const set_combinations = [
  ['X','X','X','O'],
  ['X','X','O','X'],
  ['X','O','X','X'],
  ['O','X','X','X'],
  ['X','X','O','O'],
  ['X','O','X','O'],
  ['O','X','X','O'],
  ['X','O','O','X'],
  ['O','X','O','X'],
  ['O','O','X','X'],
  ['X','O','O','O'],
  ['O','O','X','O'],
  ['O','X','O','O'],
  ['O','O','O','X'],
  ['O','O','O','O'],
]*/

const INITIAL = {
  sets      : 0,
  mistakes  : 0,
  points    : 0,
  streak    : 0,
  matches   : {},
  stars     : { 1 : 0, 2 : 0, 3 : 0 },
  goal      : [],
  moves     : 0,
  failed    : false,
  success   : false,
}

function checkForGoal(state) {
  //okay, the matches are updated. See if we've reached goal.
  //there are multiple goal states, we check each one. If any of them have succeeded, we win and can stop.
  for (let oneGoal of state.goal) {
    let goalReached = true;
    for (let goal of Object.keys(oneGoal)) {
      const goalRegex = new RegExp(goal);
      let num = 0;

      //first thing we'll do is compare all matches and total those up.
      Object.keys(state.matches).forEach( match => {
        if (match.match(goalRegex)) {
          num += state.matches[match];
        }
      });

      // next we're going to add on the various other necessities, like points, streak, etc.
      // we can be sneaky about this - if the key is defined on the state, we just add its value.
      // this covers sets, points, streak
      // XXX mistakes and points are a special case - they won't work until the user matches another set.
      if (state[goal] !== undefined) {
        num += state[goal];
        // lazy. We don't increment the sets or streak until later
        if (goal === 'sets' || goal === 'streak') {
          num++;
        }
      }

      //last, we gotta check the stars. Do 'em one at a time.
      if (goal === 'star1') {
        num += state.stars[1] || 0;
      }
      else if (goal === 'star2') {
        num += state.stars[2] || 0;
      }
      else if (goal === 'star3') {
        num += state.stars[3] || 0;
      }

      if (num < oneGoal[goal]) {
        goalReached = false;
        continue;
      }
    };
    if (goalReached) {
      return true;
    }
  }
  return false;
}

export default (state = INITIAL, action) => {

  const moves = state.moves !== undefined
    ? state.moves - 1
    : undefined;

  let failed = moves === 0
    ? failure_codes.OUT_OF_MOVES
    : false;

  switch (action.type) {
    case ADD_SET : {

      let matches = {...state.matches};


      action.payload.squares.forEach( sq => {
        var key = PROPERTIES.map(prop => sq[prop]).join('/');
        if (matches[key] === undefined) {
          matches[key] = 0;
        }
        matches[key]++;
      });

      const masterKey = PROPERTIES.map(prop => {
        return action.payload.squares.map( sq => sq[prop]).sort().join(',');
      }).join('/');

      if (matches[masterKey] === undefined) {
        matches[masterKey] = 0 ;
      }
      matches[masterKey]++;

      let newState = {
        ...state,
        sets    : state.sets + 1,
        set     : action.payload,
        streak  : state.streak + 1,
        moves,
        matches,
        failed
      };

      if (checkForGoal(state)) {
        newState.success = true;
        newState.failed = false;
      }

      return newState;

    }
    case ADD_MISTAKE : {
      let newState = { ...state, mistakes : state.mistakes + 1, set : action.payload, streak : 0, moves };
      let success = state.success;
      let failed = state.failed;
      if (checkForGoal(newState)) {
        success = true;
        failed = false;
      }

      newState.success = success;
      newState.failed = failed;

      return newState;
    }
    case ADD_POINTS : {
      let newState = {...state, points : state.points + action.payload};
      let success = state.success;
      let failed = state.failed;
      if (checkForGoal(newState)) {
        success = true;
        failed = false;
      }

      newState.success = success;
      newState.failed = failed;
      return newState;
    }
    case SET_LEVEL : {
      return {...INITIAL, ...action.payload}
    }
    case SET_LEVEL_ID : {
      return {...state, level : action.payload}
    }
    case SET_MOVES : {
      return {...state, moves : action.payload}
    }
    case SET_FAILED : {
      return {...state, failed : action.payload}
    }
    case SET_PALETTE : {
      return {...state, palette : action.payload}
    }
    case SCORE_STARS : {
      const depth = action.payload;
      return { ...state, stars : {...state.stars, [depth] : state.stars[depth] + 1} }
    }
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/level_reducer.js